import { NativeButton } from "@ad3d/ui"
import { Separator } from "@/components/ui/separator"
import { SidebarTrigger } from "@/components/ui/sidebar"
import { useAuthStore } from "../../stores/use-auth-store"
import { LoginModal } from "../login-modal"
import { useState } from "react"

export function SiteHeader() {
  const { isAuthenticated } = useAuthStore()
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false)

  return (
    <header className="sticky top-0 z-10 flex h-(--header-height) shrink-0 items-center gap-2 bg-white dark:bg-neutral-950 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
       
        <div className="ml-auto flex items-center gap-2">
          {isAuthenticated ? (
            <NativeButton variant="default" size="sm">
              Create Scene
            </NativeButton>
          ) : (
            <NativeButton 
              variant="default" 
              size="sm"
              onClick={() => setIsLoginModalOpen(true)}
            >
              Login
            </NativeButton>
          )}
        </div>
      </div>
      <LoginModal open={isLoginModalOpen} onOpenChange={setIsLoginModalOpen} />
    </header>
  )
}
